import axios from "axios";
import { GetWebAccessToken } from "../ReusebleComponents/ResuseableApiCalls";
import Call_Api from "../../Common/Handileapi/Call_api";
import { path } from "../../routes/Paths";

const apiUrl = process.env.REACT_APP_BACKEND_URL;
const apiUrlSpecial = process.env.REACT_APP_BACKEND_URLs;

export const FetchingCardLimitDetails = async (
  subService,
  card_num,
  enteredDetails,
  mobileNumber
) => {
  const token = await GetWebAccessToken();
  try {
    const Headers = {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Authorization: `Bearer ${token}`,
    };
    const response = await axios.post(
      // `${apiUrl}/serviceTracking/creditCards/limit/byDay/byMonth/${subService}/${card_num}/${mobileNumber}`,
      `${apiUrl}/serviceTracking/creditCards/limit/byDay/byMonth`,
      enteredDetails,
      {
        headers: Headers,
      }
    );
    if (response.status === 200 && response.data?.message == "valid") {
      return response.data;
    } else {
      return {
        message: "not valid",
        error: "Transaction limit is exceed",
      };
    }
  } catch (error) {
    console.log("error===>", error);
    return {
      message: "not valid",
      error: error.response?.data?.message,
    };
  }
};

export const VerifyCreditCardNumber = async (card_num, details={}) => {
  let token;
  const isDummy = localStorage.getItem("dummyUserPhoneNo") == "9999999999";

  if (isDummy) {
    token = "NTAR_DUMMY";
    console.log("Using static token for dummy user:", token);
  } else {
    token = await GetWebAccessToken();
    console.log("Got web access token:", token);
  }
  const Headers = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.post(
      `${apiUrl}/rapidDetails/validate`,
      {
        ...details,
        card_number: card_num,
        skipValidation: false,
      },
      {
        headers: Headers,
      }
    );
    console.log("response in card verify ====>>", response);
    if (response?.status === 200 && response?.data?.is_valid) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {
    console.log("error==>", error);
    return { data: {}, valid: false };
  }
};

export const FetchWalletSchemeDetails = async (details) => {
  const token = await GetWebAccessToken();
  try {
    if (details && details?.serviceName) {
      const walletSchemeName = details?.userDetails?.walletScheme;
      console.log("walletSchemeName====>>>>", walletSchemeName);
      const ObjDetails = {
        paymentMethod: details?.paymentMethod,
        paymentMode: details?.paymentMode,
        serviceName: "Settlements",
        paymentType: details?.paymentType,
        subService: details?.subService,
        walletScheme: walletSchemeName,
        creditCardNumber: details?.creditCardNumber,
        MerchantId: details?.userDetails?.MerchantId,
        amount: details?.actualAmount,
        settlementType: details?.settleMentTime,
        bankCode: details?.bankCode,
      };
      const paymentOptimiserResponse = await Call_Api(
        path?.PAYMENT_OPTIMISER,
        "POST",
        ObjDetails,
        token
      );
      console.log({ paymentOptimiserResponse });
      if (
        paymentOptimiserResponse?.response?.message?.toLowerCase() ===
        "permissions determined successfully"
      ) {
        return {
          status: true,
          data: paymentOptimiserResponse?.response,
        };
      } else {
        return {
          status: false,
          data: paymentOptimiserResponse?.response,
        };
      }
    } else {
      return {
        status: false,
        data: {},
      };
    }
  } catch (error) {
    console.log("error===>", error);
  }
};

const getAccessToken = async (MerchantId) => {
  console.log("getAccessToken===>>>>>");
  const resp = await axios.get(
    `${apiUrl}/merchant/getMerchantDetails/${MerchantId}`
  );
  return resp?.data?.response?.token;
};

const handleVerifyPayment = async (resp, data, orderId) => {
  console.log("resp, data, orderId ====>>>>>", resp, data, orderId);

  let token;
  if (
    data?.payingUserUnique == "" ||
    data?.payingUserUnique == null ||
    data?.payingUserUnique == undefined ||
    data?.payingUserUnique == "N/A"
  ) {
    token = await GetWebAccessToken();
  } else {
    token = await getAccessToken(data.MerchantId);
  }
  console.log("resp, data, orderId ====>>>>>", resp, data, orderId, token);

  const headers = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Authorization: `Bearer ${token}`,
  };

  const detailsToSendBackEnd = {
    razorpay_order_id: resp.razorpay_order_id,
    razorpay_payment_id: resp.razorpay_payment_id,
    razorpay_signature: resp.razorpay_signature,
    order_id: orderId,
    detailsToSave: data,
  };

  try {
    const verifiedResp = await axios.post(
      `${apiUrl}/RazorPayIntegration/verifyPayment`,
      detailsToSendBackEnd,
      { headers }
    );

    console.log("verifiedResp====>>>>", verifiedResp);
    if (
      verifiedResp.data &&
      (verifiedResp.status === 201 || verifiedResp.status === 200) &&
      Object.keys(verifiedResp.data).length > 0
    ) {
      return {
        status: true,
        data: verifiedResp.data,
        message: "Successfully Added",
      };
    } else {
      console.error(
        "Unexpected backend response structure:",
        verifiedResp.data
      );
      return {
        status: false,
        message: "Please reach To help Support",
      };
    }
  } catch (error) {
    console.error("Error in handleVerifyPayment:", error);
    return {
      status: false,
      message: "Please contact the Help Center",
      error: error?.response?.data || error.message,
    };
  }
};

const handleRazorpayPaymentFailed = async (errorResp, body, id) => {
  let token;
  if (
    body?.payingUserUnique == "" ||
    body?.payingUserUnique == "N/A" ||
    body?.payingUserUnique == null ||
    body?.payingUserUnique == undefined
  ) {
    token = await GetWebAccessToken();
  } else {
    token = await getAccessToken(body.MerchantId);
  }

  const headers = {
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Authorization: `Bearer ${token}`,
  };
  const razorpayData = {
    ...body,
    failuerReason: errorResp?.error?.reason || errorResp?.error?.description,
  };
  console.log({ razorpayData });

  try {
    const errorBackendResponse = await axios.post(
      `${apiUrl}/RazorPayIntegration/fetchOrder/${id}`,
      razorpayData,
      { headers }
    );
    console.log("errorBackendResponse===>>>", errorBackendResponse);
    if (
      errorBackendResponse?.data &&
      (errorBackendResponse?.status === 201 ||
        errorBackendResponse?.status === 200) &&
      Object.keys(errorBackendResponse?.data?.data).length > 0
    ) {
      return {
        status: false,
        data: errorBackendResponse?.data?.data,
        message: "Payment Failed",
      };
    } else {
      console.error(
        "Unexpected backend response structure:",
        errorBackendResponse.data
      );
      return {
        status: false,
        message: "Please reach To help Support",
      };
    }
  } catch (error) {
    console.log("error occured while fetching order :", error);
  }
};

// Create Order ID
const handleCreateOrderId = async (amountInPaise, body) => {
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
  console.log("body=========>>>>>", body);
  const details = {
    mobileNumber: body?.mobileNumber,
    userName: body?.nameOnCreditCard,
    MerchantId: body?.MerchantId,
    subService: body?.subService,
    serviceName: body?.serviceName,
    payingUserUnique: body?.payingUserUnique,
    paymentSource: body?.paymentSource,
    payIngateWay: body?.paymentGateWay,
  };
  const orderAmount = amountInPaise;
  const token = await GetWebAccessToken();
  console.log("Get webAssis token", token);

  const paymentData = {
    orderAmount,
    details,
  };

  try {
    const cashfreeOrderResponse = await Call_Api(
      path?.CREATE_CASHFREE_ORDER,
      "POST",
      paymentData,
      token
    );
    console.log({ cashfreeOrderResponse });
    return cashfreeOrderResponse.success
      ? cashfreeOrderResponse.response
      : "authentication Failed";
  } catch (error) {
    console.error("Error creating order ID:", error);
    return "Internal Server Error Please Try Again Later";
  }
};

// const handlePayUIntegration = async (amountInPaise, body) => {
//   console.log("body=========>>>>>", body);
//   const details = {
//     mobileNumber: body?.mobileNumber,
//     userName: body?.nameOnCreditCard,
//     MerchantId: body?.MerchantId,
//     subService: body?.subService,
//     serviceName: body?.serviceName,
//     payingUserUnique: body?.payingUserUnique,
//     paymentSource: body?.paymentSource,
//     payIngateWay: body?.paymentGateWay,
//   };
//   const orderAmount = amountInPaise;
//   let token;
//   if
//   const token = await GetWebAccessToken();
//   console.log("Get webAssis token", token);

//   const paymentData = {
//     orderAmount,
//     ...body,
//     details,
//   };

//   try {
//     const PayUResponse = await Call_Api(
//       path?.PAYU_INTEGRATION,
//       "POST",
//       paymentData,
//       token
//     );
//     console.log({ PayUResponse });
//     return PayUResponse.success ? PayUResponse.response : "";
//   } catch (error) {
//     console.error("Error creating order ID:", error);
//     return "Internal Server Error Please Try Again Later";
//   }
// };

const handlePayUIntegration = async (amountInPaise, body) => {
  console.log("body=========>>>>>", body);

  const details = {
    mobileNumber: body?.mobileNumber,
    userName: body?.nameOnCreditCard,
    MerchantId: body?.MerchantId,
    subService: body?.subService,
    serviceName: body?.serviceName,
    payingUserUnique: body?.payingUserUnique,
    paymentSource: body?.paymentSource,
    payIngateWay: body?.paymentGateWay,
  };

  const orderAmount = amountInPaise;

  // Use static token if dummy user'
  const isDummy = localStorage.getItem("dummyUserPhoneNo") == "9999999999";
  let token;
  if (isDummy) {
    token = "NTAR_DUMMY"; // <-- your static token here
    console.log("Using static token for dummy user:", token);
  } else {
    token = await GetWebAccessToken();
    console.log("Got web access token:", token);
  }

  const paymentData = {
    orderAmount,
    ...body,
    details,
  };

  try {
    const PayUResponse = await Call_Api(
      path?.PAYU_INTEGRATION,
      "POST",
      paymentData,
      token
    );
    console.log({ PayUResponse });
    return PayUResponse.success ? PayUResponse.response : "";
  } catch (error) {
    console.error("Error creating order ID:", error);
    return "Internal Server Error Please Try Again Later";
  }
};

export const handleGetCashfreePaymentStatus = async (orderId, storedData) => {
  const token = await GetWebAccessToken();
  console.log("payments/cashFreePayment/paymentStatus ===>", orderId);
  console.log("payments/cashFreePayment/paymentStatus ===>", storedData);
  try {
    const cashfreeStatusResponse = await Call_Api(
      path?.CASHFREE_STATUS_CHECK(orderId),
      "POST",
      storedData,
      token
    );

    console.log({ cashfreeStatusResponse });
    console.log(
      "response in cashfree status ======>>>",
      cashfreeStatusResponse?.response
    );

    return cashfreeStatusResponse.response;
  } catch (error) {
    console.error("Error fetching payment status:", error);
    return false;
  } finally {
    localStorage.clear("paymentData");
  }
};

const submitPayUForm = (paymentHTML) => {
  const newWindow = window.open("", "_self"); // open in same tab
  newWindow.document.open();
  newWindow.document.write(paymentHTML);
  newWindow.document.close();
};

export const handleFetchPaymentIntegration = async (finalObj) => {
  console.log("handleFetchpaymentIntegration is called", finalObj);
  const token = await GetWebAccessToken();
  const Header = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Authorization: `Bearer ${token}`,
  };

  try {
    let amountInPaise =
      finalObj?.serviceName?.toLowerCase() != "settlements"
        ? parseFloat(finalObj?.finalPayableAmount)
        : parseFloat(finalObj?.actualAmount) ||
          parseFloat(finalObj?.finalPayableAmount);
    console.log("handleFetchpaymentIntegration is called", amountInPaise);
    if (
      (!Number.isInteger(amountInPaise) || amountInPaise <= 0) &&
      finalObj?.serviceName?.toLowerCase() == "settlements"
    ) {
      return {
        status: false,
        message: "Invalid Input: Amount must be a positive integer.",
      };
    }

    if (
      Number(amountInPaise) <= 0 &&
      finalObj?.serviceName?.toLowerCase() != "settlements"
    ) {
      return {
        status: false,
        message: "Invalid Input: Amount must be a positive Number.",
      };
    }

    const now = new Date();
    const date = now.toISOString().slice(0, 10).replace(/-/g, "");
    const time = now.toISOString().slice(11, 19).replace(/:/g, "");
    const randomComponent = Math.random()
      .toString(36)
      .substr(2, 4)
      .toUpperCase();
    const transactionId = `BIZZ_${date}${time}${randomComponent}`;
    console.log("finalObject before====>>>", finalObj);

    let body = {
      ...finalObj,
      amount: finalObj?.finalPayableAmount,
      MerchantId: finalObj?.userDetails?.MerchantId,
      userName: finalObj?.userDetails?.userName,
      creditCardCVV: finalObj?.cvv,
      creditCardExpiryMonth: finalObj?.monthAndYear?.split("/")?.[0],
      creditCardExpiryYear: finalObj?.monthAndYear?.split("/")?.[1],
      customerMobileNumber: finalObj?.mobileNumber,
      mobileNumber: finalObj?.userDetails?.mobileNumber,
      nameOnCreditCard: finalObj?.holderName,
      ntarTransactionId: transactionId,
      payIngateWay: finalObj?.paymentGateWay,
      totalAmount: finalObj?.finalPayableAmount,
      transactionType: finalObj?.transactionType,
      payingUserUnique: finalObj?.payingUserUnique || "N/A",
      referredBy: finalObj?.referredBy || "N/A",
    };

    console.log("body==>>>", body);

    const skipKeys = ["ip"];

    const validate = Object.keys(body)
      .filter((key) => !skipKeys.includes(key))
      .every((key) => body[key] !== "");

    if (!validate) {
      console.log("validate===>", validate);
      return {
        status: false,
        message: "Some Required Values are missing, Please Try Again",
      };
    }
    console.log("body==>>>", body);

    if (finalObj?.paymentGateWay?.toUpperCase()?.includes("RAZORPAY")) {
      const createOrder = await axios.post(
        `${apiUrl}/RazorPayIntegration/createOrder`,
        body,
        {
          headers: Header,
        }
      );
      if (!createOrder?.data?.success) {
        return {
          gatewayError: true,
          message: "Razorpay order creation failed",
        };
      }
      if (createOrder?.data && createOrder?.data?.success) {
        console.log("body==>>>", body, createOrder);
        const keyres = await axios.post(
          `${apiUrl}/RazorpayIntegration/api/getkey`,
          body,
          {
            headers: Header,
          }
        );
        const razorpayKey = keyres.data.key;

        const { amount, id } = createOrder?.data?.order;

        const data = {
          amount:
            body?.serviceName?.toLowerCase() != "settlements"
              ? Number(body?.totalAmount) * 100
              : amountInPaise * 100,
          key_id: razorpayKey,
          currency: "INR",
          // email: finalObj?.userDetails?.email || "userExample@gmail.com",
          email: "void@gmail.com",
          contact: finalObj?.mobileNumber,
          order_id: id,
          method: "card",
          "card[name]": finalObj?.holderName,
          "card[number]": finalObj?.creditCardNumber,
          "card[expiry_month]": finalObj?.monthAndYear?.split("/")[0],
          "card[expiry_year]": finalObj?.monthAndYear?.split("/")[1],
          "card[cvv]": finalObj?.cvv,
        };

        const razorPayData = { orderID: id, bodyData: body };

        // await localStorage.setItem("razorpayData", JSON.stringify(razorPayData));

        // let getPaid = body?.payingUserUnique === "N/A" ? true : false;
        // console.log("body?.payingUserUnique ==>>>", body?.payingUserUnique);
        // console.log("getPaid ==>>>", typeof getPaid , getPaid);

        let razorpay = await new window.Razorpay({
          key: razorpayKey,
          // redirect: true,
          // callback_url: `${apiUrlSpecial}/RazorpayIntegration/catch/${getPaid}`,
        });

        return new Promise((resolve) => {
          razorpay.createPayment(data);

          razorpay.on("payment.error", async (errorResp) => {
            console.log("payment.error====>", errorResp);
            try {
              const response = await handleRazorpayPaymentFailed(
                errorResp,
                body,
                id
              );

              console.log("response===>>>>", response);
              resolve(response);
            } catch (error) {
              console.error("Payment verification failed:", error);

              resolve({
                status: false,
                message: "Something went Wrong. Please Try again",
              });
            }
          });

          razorpay.on("payment.success", async (successResp) => {
            console.log("Payment succeeded:", successResp);

            try {
              const verifyPaymentStatusawait = await handleVerifyPayment(
                successResp,
                body,
                id
              );

              resolve(verifyPaymentStatusawait);
            } catch (verificationError) {
              console.error("Payment verification failed:", verificationError);

              resolve({
                status: false,
                message: "Something went Wrong. Please Try again",
              });
            }
          });
        });
      }
    }

    if (finalObj?.paymentGateWay?.toUpperCase()?.includes("PLURAL")) {
      const resss = await axios.post(
        `${apiUrl}/pluralIntegration/generate/token`,
        body,
        {
          headers: Header,
        }
      );

      if (!resss?.data?.checkoutUrl) {
        return { gatewayError: true, message: "Plural order creation failed" };
      }

      if (resss?.data?.checkoutUrl) {
        console.log("resss-===>>>", resss);
        // setPluralCheckOutUrl(resss?.data?.checkoutUrl);
        let pluralData = {
          ...body,
          ...resss?.data,
        };
        localStorage.setItem("pluralData", JSON.stringify(pluralData));
        return resss?.data;
      }
    }

    if (finalObj?.paymentGateWay?.toUpperCase()?.includes("PHONEPE")) {
      const phonepeResss = await Call_Api(
        path?.GET_PHONEPE_ORDERID,
        "POST",
        body,
        token
      );

      console.log("phonepeResss ====>>", phonepeResss);

      if (
        !phonepeResss?.response?.success ||
        !phonepeResss?.response?.data?.redirectUrl
      ) {
        return { gatewayError: true, message: "PhonePe order creation failed" };
      }

      if (
        phonepeResss?.response?.data?.redirectUrl &&
        phonepeResss?.response?.success
      ) {
        let phonepeData = {
          ...body,
          ...phonepeResss?.response?.data,
        };
        localStorage.setItem("phonepeData", JSON.stringify(phonepeData));
        return phonepeResss?.response?.data;
      }
    }

    if (
      finalObj?.paymentGateWay?.toUpperCase() === "CASHFREE_BBPS" ||
      finalObj?.paymentGateWay?.toUpperCase() === "CASHFREE_OPTIMISER"
    ) {
      const createOrderResp = await handleCreateOrderId(amountInPaise, body);
      if (!createOrderResp) {
        return {
          gatewayError: true,
          message: "Cashfree order creation failed",
        };
      }
      return { createOrderResp, body };
    }

    if (finalObj?.paymentGateWay?.toUpperCase()?.includes("CASHFREEWEBVIEW")) {
      const cashFreeWebViewResponse = await Call_Api(
        path?.CASHFREE_WEBVIEW,
        "POST",
        body,
        token
      );

      console.log(
        "response of CASHFREEWEBVIEW webview create order==>",
        cashFreeWebViewResponse
      );
      if (
        cashFreeWebViewResponse?.code == "request_invalid" ||
        cashFreeWebViewResponse?.message ==
          "Please try again or use another card"
      ) {
        return { message: "Please check your card Details or try again" };
      }
      const paymentUrl = cashFreeWebViewResponse?.response?.paymentDetails?.url;
      const orderId = cashFreeWebViewResponse?.response?.orderId;
      const paymentId = cashFreeWebViewResponse?.response?.paymentId;

      if (!paymentUrl || !orderId || !paymentId) {
        return {
          gatewayError: true,
          message: "Cashfree order creation failed",
        };
      }

      const cashfreeWebData = {
        paymentUrl,
        orderId,
        paymentId,
        body,
      };
      localStorage.setItem("cashfreeWebData", JSON.stringify(cashfreeWebData));
      if (paymentUrl) {
        console.log("navigate to cash free webView");
        return {
          payUrl: paymentUrl,
        };
      }
    }

    if (finalObj?.paymentGateWay?.toUpperCase()?.includes("PAYU")) {
      // const PayUResp = await handlePayUIntegration(amountInPaise, body);

      const payUResponse = await handlePayUIntegration(amountInPaise, body);
      console.log("PayUResp===>>>", payUResponse);
      const {
        creditCardNumber,
        creditCardCVV,
        creditCardExpiryMonth,
        creditCardExpiryYear,
        ...safeBody
      } = body;

      if (payUResponse?.success && payUResponse?.paymentURL) {
        localStorage.setItem(
          "payUData",
          JSON.stringify({
            transactionId: payUResponse.transactionId,
            ...safeBody,
          })
        );
        submitPayUForm(payUResponse.paymentURL);
        return {
          status: true,
          PayUResp: payUResponse,
        };
      } else {
        console.error("Failed to get valid PayU form.");
        return { gatewayError: true, message: "PayU order creation failed" };
      }
    }

    if (finalObj?.paymentGateWay?.toUpperCase()?.includes("CASHFREE")) {
      const cashFreeFastagResponse = await Call_Api(
        path?.CASHFREE_SEAMLESS,
        "POST",
        body,
        token
      );

      console.log(
        "response of CASHFREE_FASTAG create order==>",
        cashFreeFastagResponse
      );
      if (
        cashFreeFastagResponse?.code == "request_invalid" ||
        cashFreeFastagResponse?.message ==
          "Please try again or use another card"
      ) {
        return { message: "Please check your card Details or try again" };
      }
      const paymentUrl =
        cashFreeFastagResponse?.response?.paymentDetails?.data?.url;
      const orderId = cashFreeFastagResponse?.response?.orderId;
      const paymentId = cashFreeFastagResponse?.response?.paymentId;

      if (!paymentUrl) {
        return {
          gatewayError: true,
          message: "Cashfree order creation failed",
        };
      }

      const cashfreeFastagData = {
        paymentUrl,
        orderId,
        paymentId,
        body,
      };
      localStorage.setItem(
        "cashfreeFastagData",
        JSON.stringify(cashfreeFastagData)
      );
      if (paymentUrl) {
        console.log("navigate to cash free fastag");
        return {
          payUrl: paymentUrl,
        };
      }
    }
  } catch (error) {
    console.log("error===>", error);
    if (
      error?.response?.data?.code?.toLowerCase() === "card_number_invalid" ||
      error?.response?.data?.message?.toLowerCase() ===
        "card_number : invalid card number entered "
    ) {
      return { message: "Please check your card Details or try again" };
    }
    return {
      status: false,
      message: "Something went Wrong. Please Try again",
    };
  }
};

// export const handleFetchPaymentIntegrationDummy = async (finalObj) => {
//   try {
//     console.log("Dummy payment integration called", finalObj);

//     // finalObj.paymentGateWay = "PAYU";

//     const token = await GetWebAccessToken();
//     const Header = {
//       "Content-Type": "application/json",
//       "Cache-Control": "no-cache",
//       Pragma: "no-cache",
//       Authorization: `Bearer ${token}`,
//     };

//     const amountInPaise = finalObj?.finalPayableAmount;

//     const body = {
//       ...finalObj,
//       amount: finalObj?.finalPayableAmount,
//       MerchantId: finalObj?.userDetails?.MerchantId,
//       creditCardCVV: finalObj?.cvv,
//       creditCardExpiryMonth: finalObj?.monthAndYear?.split("/")?.[0],
//       creditCardExpiryYear: finalObj?.monthAndYear?.split("/")?.[1],
//       nameOnCreditCard: finalObj?.holderName,
//       userName: finalObj?.userDetails?.userName,
//       customerMobileNumber: finalObj?.mobileNumber,
//       mobileNumber: finalObj?.userDetails?.mobileNumber,
//       transactionType: finalObj?.transactionType || "Credit",
//       payIngateWay: "PAYU",
//       referredBy: finalObj?.referredBy || "N/A",
//     };

//     const response = await handlePayUIntegration(amountInPaise, body);

//     console.log("Dummy PayU response", response);
//     if (response?.success && response?.paymentURL) {
//       localStorage.setItem(
//         "payUData",
//         JSON.stringify({
//           transactionId: response.transactionId,
//           ...body,
//         })
//       );
//       submitPayUForm(response.paymentURL);
//     } else {
//       console.error("Failed to get valid PayU form.");
//       return { message: "Something Went Wrong Please Try Again" };
//     }
//   } catch (error) {
//     console.error("Error in dummy payment integration:", error);
//     return { status: false, message: "Dummy payment failed, please try again" };
//   }
// };

export const handleFetchPaymentIntegrationDummy = async (finalObj) => {
  try {
    console.log("Dummy payment integration called", finalObj);

    finalObj.paymentGateWay = "CASHFREE_FERRY";

    const token = await GetWebAccessToken();
    const Header = {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Authorization: `Bearer ${token}`,
    };

    const amountInPaise = finalObj?.finalPayableAmount;

    const body = {
      ...finalObj,
      amount: finalObj?.finalPayableAmount,
      MerchantId: finalObj?.userDetails?.MerchantId,
      creditCardCVV: finalObj?.cvv,
      creditCardExpiryMonth: finalObj?.monthAndYear?.split("/")?.[0],
      creditCardExpiryYear: finalObj?.monthAndYear?.split("/")?.[1],
      nameOnCreditCard: finalObj?.holderName,
      userName: finalObj?.userDetails?.userName,
      customerMobileNumber: finalObj?.mobileNumber,
      mobileNumber: finalObj?.userDetails?.mobileNumber,
      transactionType: finalObj?.transactionType || "Credit",
      payIngateWay: "CASHFREE_FERRY",
      referredBy: finalObj?.referredBy || "N/A",
    };

    if (body?.payIngateWay?.toUpperCase() == "RAZORPAY") {
      const createOrder = await axios.post(
        `${apiUrl}/RazorPayIntegration/createOrder`,
        body,
        {
          headers: Header,
        },
      );
      if (!createOrder?.data?.success) {
        return {
          gatewayError: true,
          message: "Razorpay order creation failed",
        };
      }
      if (createOrder?.data && createOrder?.data?.success) {
        console.log("body==>>>", body, createOrder);
        const keyres = await axios.post(
          `${apiUrl}/RazorpayIntegration/api/getkey`,
          body,
          {
            headers: Header,
          },
        );
        const razorpayKey = keyres.data.key;

        const { amount, id } = createOrder?.data?.order;

        const data = {
          amount:
            body?.serviceName?.toLowerCase() != "settlements"
              ? Number(body?.totalAmount) * 100
              : amountInPaise * 100,
          key_id: razorpayKey,
          currency: "INR",
          // email: finalObj?.userDetails?.email || "userExample@gmail.com",
          email: "void@gmail.com",
          contact: finalObj?.mobileNumber,
          order_id: id,
          method: "card",
          "card[name]": finalObj?.holderName,
          "card[number]": finalObj?.creditCardNumber,
          "card[expiry_month]": finalObj?.monthAndYear?.split("/")[0],
          "card[expiry_year]": finalObj?.monthAndYear?.split("/")[1],
          "card[cvv]": finalObj?.cvv,
        };

        const razorPayData = { orderID: id, bodyData: body };

        // await localStorage.setItem("razorpayData", JSON.stringify(razorPayData));

        // let getPaid = body?.payingUserUnique === "N/A" ? true : false;
        // console.log("body?.payingUserUnique ==>>>", body?.payingUserUnique);
        // console.log("getPaid ==>>>", typeof getPaid , getPaid);

        let razorpay = await new window.Razorpay({
          key: razorpayKey,
          // redirect: true,
          // callback_url: `${apiUrlSpecial}/RazorpayIntegration/catch/${getPaid}`,
        });

        return new Promise((resolve) => {
          razorpay.createPayment(data);

          razorpay.on("payment.error", async (errorResp) => {
            console.log("payment.error====>", errorResp);
            try {
              const response = await handleRazorpayPaymentFailedDummy(
                errorResp,
                body,
                id,
              );

              console.log("response===>>>>", response);
              resolve(response);
            } catch (error) {
              console.error("Payment verification failed:", error);

              resolve({
                status: false,
                message: "Something went Wrong. Please Try again",
              });
            }
          });

          razorpay.on("payment.success", async (successResp) => {
            console.log("Payment succeeded:", successResp);

            try {
              const verifyPaymentStatusawait = await handleVerifyPaymentDummy(
                successResp,
                body,
                id,
              );

              resolve(verifyPaymentStatusawait);
            } catch (verificationError) {
              console.error("Payment verification failed:", verificationError);

              resolve({
                status: false,
                message: "Something went Wrong. Please Try again",
              });
            }
          });
        });
      }
    } else if (finalObj?.paymentGateWay?.toUpperCase()?.includes("CASHFREE")){
       const cashFreeFastagResponse = await Call_Api(
        path?.CASHFREE_SEAMLESS,
        "POST",
        body,
        token,
      );

      console.log(
        "response of CASHFREE_FASTAG create order==>",
        cashFreeFastagResponse,
      );
      if (
        cashFreeFastagResponse?.code == "request_invalid" ||
        cashFreeFastagResponse?.message ==
          "Please try again or use another card"
      ) {
        return { message: "Please check your card Details or try again" };
      }
      const paymentUrl =
        cashFreeFastagResponse?.response?.paymentDetails?.data?.url;
      const orderId = cashFreeFastagResponse?.response?.orderId;
      const paymentId = cashFreeFastagResponse?.response?.paymentId;

      if (!paymentUrl) {
        return {
          gatewayError: true,
          message: "Cashfree order creation failed",
        };
      }

      const cashfreeFastagData = {
        paymentUrl,
        orderId,
        paymentId,
        body,
      };
      localStorage.setItem(
        "cashfreeFastagData",
        JSON.stringify(cashfreeFastagData),
      );
      if (paymentUrl) {
        console.log("navigate to cash free fastag");
        return {
          payUrl: paymentUrl,
        };
      }
    }
       const response = await handlePayUIntegration(amountInPaise, body);
  

    console.log("Dummy PayU response", response);
    if (response?.success && response?.paymentURL) {
      localStorage.setItem(
        "payUData",
        JSON.stringify({
          transactionId: response.transactionId,
          ...body,
        }),
      );
      submitPayUForm(response.paymentURL);
    } else {
      console.error("Failed to get valid PayU form.");
      return { message: "Something Went Wrong Please Try Again" };
    }
  } catch (error) {
    console.error("Error in dummy payment integration:", error);
    return { status: false, message: "Dummy payment failed, please try again" };
  }
};

const handleVerifyPaymentDummy = async (resp, data, orderId) => {
  console.log("resp, data, orderId ====>>>>>", resp, data, orderId);

  let token;
  if (
    data?.payingUserUnique == "" ||
    data?.payingUserUnique == null ||
    data?.payingUserUnique == undefined ||
    data?.payingUserUnique == "N/A"
  ) {
    token = await GetWebAccessToken();
  } else {
    token = await getAccessToken(data.MerchantId);
  }
  console.log("resp, data, orderId ====>>>>>", resp, data, orderId, token);

  const headers = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Authorization: `Bearer ${token}`,
  };

  const detailsToSendBackEnd = {
    razorpay_order_id: resp.razorpay_order_id,
    razorpay_payment_id: resp.razorpay_payment_id,
    razorpay_signature: resp.razorpay_signature,
    order_id: orderId,
    detailsToSave: data,
  };

  try {
    const verifiedResp = await axios.post(
      `${apiUrl}/RazorPayIntegration/verifyPayment`,
      detailsToSendBackEnd,
      { headers },
    );

    console.log("verifiedResp====>>>>", verifiedResp);
    if (
      verifiedResp.data &&
      (verifiedResp.status === 201 || verifiedResp.status === 200) &&
      Object.keys(verifiedResp.data).length > 0
    ) {
      return {
        status: true,
        data: verifiedResp.data,
        message: "Successfully Added",
      };
    } else {
      console.error(
        "Unexpected backend response structure:",
        verifiedResp.data,
      );
      return {
        status: false,
        message: "Please reach To help Support",
      };
    }
  } catch (error) {
    console.error("Error in handleVerifyPayment:", error);
    return {
      status: false,
      message: "Please contact the Help Center",
      error: error?.response?.data || error.message,
    };
  }
};

const handleRazorpayPaymentFailedDummy = async (errorResp, body, id) => {
  let token;
  if (
    body?.payingUserUnique == "" ||
    body?.payingUserUnique == "N/A" ||
    body?.payingUserUnique == null ||
    body?.payingUserUnique == undefined
  ) {
    token = await GetWebAccessToken();
  } else {
    token = await getAccessToken(body.MerchantId);
  }

  const headers = {
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Authorization: `Bearer ${token}`,
  };
  const razorpayData = {
    ...body,
    failuerReason: errorResp?.error?.reason || errorResp?.error?.description,
  };
  console.log({ razorpayData });

  try {
    const errorBackendResponse = await axios.post(
      `${apiUrl}/RazorPayIntegration/fetchOrder/${id}`,
      razorpayData,
      { headers },
    );
    console.log("errorBackendResponse===>>>", errorBackendResponse);
    if (
      errorBackendResponse?.data &&
      (errorBackendResponse?.status === 201 ||
        errorBackendResponse?.status === 200) &&
      Object.keys(errorBackendResponse?.data?.data).length > 0
    ) {
      return {
        status: false,
        data: errorBackendResponse?.data?.data,
        message: "Payment Failed",
      };
    } else {
      console.error(
        "Unexpected backend response structure:",
        errorBackendResponse.data,
      );
      return {
        status: false,
        message: "Please reach To help Support",
      };
    }
  } catch (error) {
    console.log("error occured while fetching order :", error);
  }
};

export const verifyPluralPayment = async (paymentData) => {
  const token = await GetWebAccessToken();
  const headers = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Authorization: `Bearer ${token}`,
  };
  console.log("paymentData===>>>", paymentData);
  try {
    const response = await axios.post(
      `${apiUrl}/pluralIntegration/verify-payment`,
      paymentData,
      {
        headers: headers,
      }
    );
    console.log("response pyment===>>", response?.data);

    return {
      message: "Payment succesfull",
      status: true,
      trasaction: response?.data,
    };
  } catch (error) {
    console.log("Error occured while verifying payment :", error);
    return {
      message: error?.response?.data?.message,
      status: error?.response?.data?.status,
      trasaction: error?.response?.data?.transaction,
    };
  }
};

export const handleGetWebViewPaymentStatus = async (
  orderId,
  paymentId,
  storedData
) => {
  const token = await GetWebAccessToken();
  const headers = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.post(
      `${apiUrl}/cashFreeWebView/get/payment/status/cashFree/webView/${orderId}/${paymentId}`,
      storedData?.body || {},
      {
        headers: headers,
      }
    );

    console.log("response in cashfree status ======>>>", response);
    console.log("response in cashfree status ======>>>", response?.data);

    return response.data;
  } catch (error) {
    console.error("Error fetching payment status:", error);
    return false;
  } finally {
    localStorage.clear("cashfreeWebData");
  }
};

export const handleGetSeamlessPaymentStatus = async (
  orderId,
  paymentId,
  storedData
) => {
  const token = await GetWebAccessToken();
  console.log("token in handleGetSeamlessPaymentStatus ===>>", token);
  const Header = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.post(
      `${apiUrl}/CashFreeSeamLess/get/payment/status/${orderId}/${paymentId}`,
      storedData?.body || {},
      {
        headers: Header,
      }
    );

    console.log("response in cashfree status ======>>>", response);

    return response.data;
  } catch (error) {
    console.error("Error fetching payment status:", error);
    return false;
  } finally {
    localStorage.clear("cashfreeWebData");
  }
};

export const handleGetPayUPaymentStatus = async (orderId, storedData) => {
  let token;

  // Check if dummy user
  const isDummy = localStorage.getItem("dummyUserPhoneNo") == "9999999999";
  if (isDummy) {
    token = "NTAR_DUMMY";
    console.log("Using static token for dummy user:", token);
  } else {
    token = await GetWebAccessToken();
    console.log("Got web access token:", token);
  }

  console.log("storedData in status call", JSON.stringify(storedData));

  const Header = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      `${apiUrl}/payU/getPayuTransactionDetailsById/${orderId}`,
      storedData || {},
      {
        headers: Header,
      }
    );

    console.log("response in payU status ======>>>", response);

    return response.data;
  } catch (error) {
    console.error("Error fetching payment status:", error);
    return false;
  } finally {
    localStorage.removeItem("cashfreeWebData"); // corrected clear usage
  }
};

export const handleGetPhonepePaymentStatus = async (orderId, storedData) => {
  const token = await GetWebAccessToken();
  console.log("storedData in status call", JSON.stringify(storedData));
  const Header = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.post(
      `${apiUrl}/phonepe/payments/transactionStatus`,
      storedData || {},
      {
        headers: Header,
      }
    );

    console.log("response in cashfree status ======>>>", response);

    return response.data;
  } catch (error) {
    console.error("Error fetching payment status:", error);
    return false;
  } finally {
    localStorage.clear("cashfreeWebData");
  }
};
